module.exports = __webpack_public_path__ + "static/img/ja.ae08fd19.png";